module.exports = __webpack_public_path__ + "static/img/failure.c0fb1157.svg";